import React from "react";
import PageWrapper from "./PageWrapper";

export default function StudyLaunchError() {
  return (
    <PageWrapper>
      <main style={{ maxWidth: "640px", margin: "0 auto", textAlign: "center", padding: "3rem 1.5rem" }}>
        <h1>The study could not be opened</h1>
        <p>The participant link is incomplete or invalid. Please return to Prolific and open the study again.</p>
      </main>
    </PageWrapper>
  );
}
